import api from './axiosApi'
import type { UserSummary } from './shares'

// Types from OpenAPI spec
export type SubmissionStatus =
  | 'PENDING'
  | 'APPROVED'
  | 'REJECTED'
  | 'WITHDRAWN'
  | 'SENT_BACK'
  | 'UNAPPROVED'

export interface SubmissionCreateBody {
  notes?: string | null
  reviewer_id?: string | null
}

export interface PlanSubmissionRead {
  id: string
  version_id: string
  status: SubmissionStatus
  notes: string | null
  submitted_at: string
  submitted_by: UserSummary | null
  decided_at: string | null
  decided_by: UserSummary | null
  decision_notes: string | null
  reviewer_id: UserSummary | null
  seen_by_approver: boolean
}

/**
 * Submit plan for review via POST /plans/{plan_id}/submissions
 * This submits the active version of the plan for manager review.
 */
export async function submitPlanForReview(
  planId: string,
  data?: SubmissionCreateBody
): Promise<PlanSubmissionRead> {
  const response = await api.post<PlanSubmissionRead>(
    `/plans/${planId}/submissions`,
    data ?? {}
  )
  return response.data
}

/**
 * Fetch submission history for the active version of a plan.
 * GET /plans/{plan_id}/submissions
 */
export async function fetchPlanSubmissions(
  planId: string
): Promise<PlanSubmissionRead[]> {
  const response = await api.get<PlanSubmissionRead[]>(
    `/plans/${planId}/submissions`
  )
  return response.data
}

/**
 * Unsubmit a pending submission (withdraw before manager decides).
 * POST /plans/{plan_id}/submissions/{submission_id}/unsubmit
 */
export async function unsubmitPlan(
  planId: string,
  submissionId: string
): Promise<void> {
  await api.post(`/plans/${planId}/submissions/${submissionId}/unsubmit`)
}
